var React = require('react');

function IconTextCloud (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"none","d":"M-1-1h582v402H-1z","key":0}),React.createElement("g",{"key":1},React.createElement("path",{"stroke":"#0095ff","d":"M2.204 31.553l13.077 5.465v22.828c0 1.667 1.648 3.018 3.68 3.018h396.296c2.032 0 3.68-1.351 3.68-3.018V4.018c0-1.667-1.648-3.018-3.68-3.018H18.96c-2.031 0-3.679 1.351-3.679 3.018v22.077L2.204 31.553z","fill":"none","strokeWidth":"2"}))]);
}

IconTextCloud.defaultProps = {"viewBox":"0 0 420 64"};

module.exports = IconTextCloud;

IconTextCloud.default = IconTextCloud;
